import React, { Component } from "react";
import { connect } from "react-redux";
import { PERMISSION_ARTICLES_WRITE } from "../../constants";
import WithAjax from "../common/helpers/WithAjax";
import { setJumbotronTitle } from "../../actions/common";
import { checkPermission } from "../common/functions/permissions";
import Table from "../../tables/reactable/DefaultTable";
import StatusBadge from "../common/helpers/StatusBadge";
import ProtectedElement from "../common/helpers/ProtectedElement";

class ArticleList extends Component {
  constructor() {
    super();
    this.onChangeItemsPerPage = this.onChangeItemsPerPage.bind(this);
    this.onSearch = this.onSearch.bind(this);
    this.onFilter = this.onFilter.bind(this);
    this.state = {
      items: [],
      itemsPerPage: 10,
      openBtnVisible: checkPermission(PERMISSION_ARTICLES_WRITE),
      openBtnLabel: "Edit",
      search: "",
      filter: {
        Status: "active",
      },
    };
    this.columns = ["Image", "Title", "PublishDate", "Views", "Status"];
    this.columnNames = ["", "Title", "Publish date", "Views", "Status"];

    this.handleAdd = this.handleAdd.bind(this);
  }

  componentDidMount() {
    let url = "articles?Limit=10000";

    this.props.setJumbotronTitle("News");

    this.props.ajax.get(url, true, (data) => {
      data.forEach((el, index) => {
        return (data[index].NavigationParam = data[index].Id);
      });

      this.setState({
        items: Array.from(data),
      });
    });
  }

  onChangeItemsPerPage(e) {
    e.preventDefault();
    this.setState({
      itemsPerPage: e.target.value,
    });
    return false;
  }

  handleAdd(event) {
    event.preventDefault();
    this.props.history.push("/news/add");
  }

  onSearch(e) {
    e.preventDefault();
    this.setState({
      search: e.target.value,
    });
    return false;
  }

  onFilter(filter) {
    this.setState({
      filter: filter,
    });
  }

  render() {
    let items = this.state.items.map((item) => {
      return Object.assign({}, item, {
        Status: <StatusBadge status={item.Status.toLowerCase()} statusLabel={item.Status === "Finished" ? "Archived" : item.Status} />,
        Image: <img src={item.ImageUrl} style={{ width: "50px" }} alt="" />,
      });
    });

    let addBtn = (
      <div className="row">
        <div className="col-md-12 text-right pb-3">
          <ProtectedElement permission={PERMISSION_ARTICLES_WRITE}>
            <button className="btn btn-rounded btn-primary" onClick={this.handleAdd}>
              Add
            </button>
          </ProtectedElement>
        </div>
      </div>
    );

    return (
      <div>
        {addBtn}
        <Table
          items={items}
          columns={this.columns}
          columnNames={this.columnNames}
          itemsPerPage={this.state.itemsPerPage}
          searchable={["Title"]}
          search={this.state.search}
          onSearch={this.onSearch}
          filterable={[
            {
              column: "Status",
              filters: [
                {
                  value: "active",
                  label: "Active",
                },
                {
                  value: "pending",
                  label: "Pending",
                },
                {
                  value: "finished",
                  label: "Archived",
                },
              ],
            },
          ]}
          filter={this.state.filter}
          onFilter={this.onFilter}
          onChangeItemsPerPage={this.onChangeItemsPerPage}
          openBtnVisible={this.state.openBtnVisible}
          openBtnLabel={this.state.openBtnLabel}
          openBtnHref="/news/{NavigationParam}/edit"
          sortable={["Title", "PublishDate"]}
          defaultSort={{ column: "PublishDate", direction: "desc" }}
        />
        {addBtn}
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => ({});
const mapDispatchToProps = (dispatch) => ({
  setJumbotronTitle(title) {
    dispatch(setJumbotronTitle(title));
  },
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(WithAjax(ArticleList));
